module.exports = __webpack_public_path__ + "img/Manufacturing_new_stock.ed9b6cad.svg";